import React from "react"
import styled from "styled-components"
import { StaticImage } from "gatsby-plugin-image"

const AvailabilityImg = () => {
  return (
    <Wrapper>
      <div className="img-container">
        <StaticImage
          className="img"
          src="../../assets/images/availability-form.jpg"
          layout="constrained"
          alt="contacto"
          placeholder="blurred"
        />
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  .img-container {
    width: auto;
    margin-top: 2rem;
  }
  .img {
    max-height: 600px;
  }

  @media screen and (min-width: 992px) {
    margin-top: 0;
    max-width: 500px;
    width: 40%;
  }
`

export default AvailabilityImg
